// extracted by mini-css-extract-plugin
module.exports = {"stickyDiv":"style_stickyDiv__Kag_6","stickyButton":"style_stickyButton__HNVQN"};